<template lang="pug">
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } =
  createNamespacedHelpers('auth')

export default {
  computed: {
    ...mapStateAuth(['uid'])
  },
  mounted() {
    console.log('redirect', this.$route.params.r)
    let query = '?'
    let queryArray = Object.entries(this.$route.query)
    for (let index = 0; index < queryArray.length; index++) {
      query += `${queryArray[index][0]}=${queryArray[index][1]}`
      if (index !== queryArray.length - 1) query += '&'
    }
    console.log(
      'redirect',
      `/${this.$route.params.r.replaceAll('-', '/')}${query}`
    )
    setTimeout(() => {
      this.$router.push(`/${this.$route.params.r.replaceAll('-', '/')}${query}`)
    }, 1000)
  },
  methods: {
    ...mapActionsAuth(['signOut']),
    logout() {
      this.signOut()
      setTimeout(() => {
        this.$router.push('/login')
      }, 400)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
</style>
